//#region ENUM EDevicePermissions
/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Permissions
 *
 * They can only be
 * {@link PermissionName}
 */
export enum EDevicePermissions {
  Camera = 'camera',
  ClipboardRead = 'clipboard-read',
  ClipboardWrite = 'clipboard-write',
  Geolocation = 'geolocation',
  Microphone = 'microphone',
  Midi = 'midi',
  Notifications = 'notifications',
  PersistentStorage = 'persistent-storage',
  StorageAccess = 'storage-access',
  ScreenWakeLock = 'screen-wake-lock',
}

//#endregion

//#region TYPE TDevicePermissions
export type TDevicePermissions = `${EDevicePermissions}`;
//#endregion

//#region ENUM EDevicePermissionState
export enum EDevicePermissionState {
  denied = 'denied',
  error = 'error',
  granted = 'granted',
  notSupported = 'not-supported',
  prompt = 'prompt'
}

//#endregion

//#region TYPE TDevicePermissionState
export type TDevicePermissionState = `${EDevicePermissionState}`;
//#endregion
